import { avatarAnatomy as v } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as y, cssVar as s, defineStyle as c } from "@chakra-ui/styled-system";
import { randomColor as m, isDark as p } from "@chakra-ui/theme-tools";
import u from "../foundations/sizes.mjs";
const { definePartsStyle: f, defineMultiStyleConfig: h } = y(v.keys), o = s("avatar-border-color"), l = s("avatar-bg"), n = s("avatar-font-size"), t = s("avatar-size"), x = c({
  borderRadius: "full",
  border: "0.2em solid",
  borderColor: o.reference,
  [o.variable]: "white",
  _dark: {
    [o.variable]: "colors.gray.800"
  }
}), $ = c({
  bg: l.reference,
  fontSize: n.reference,
  width: t.reference,
  height: t.reference,
  lineHeight: "1",
  [l.variable]: "colors.gray.200",
  _dark: {
    [l.variable]: "colors.whiteAlpha.400"
  }
}), k = c((r) => {
  const { name: e, theme: d } = r, i = e ? m({ string: e }) : "colors.gray.400", g = p(i)(d);
  let b = "white";
  return g || (b = "gray.800"), {
    bg: l.reference,
    fontSize: n.reference,
    color: b,
    borderColor: o.reference,
    verticalAlign: "top",
    width: t.reference,
    height: t.reference,
    "&:not([data-loaded])": {
      [l.variable]: i
    },
    [o.variable]: "colors.white",
    _dark: {
      [o.variable]: "colors.gray.800"
    }
  };
}), w = c({
  fontSize: n.reference,
  lineHeight: "1"
}), C = f((r) => ({
  badge: x,
  excessLabel: $,
  container: k(r),
  label: w
}));
function a(r) {
  const e = r !== "100%" ? u[r] : void 0;
  return f({
    container: {
      [t.variable]: e != null ? e : r,
      [n.variable]: "calc(".concat(e != null ? e : r, " / 2.5)")
    },
    excessLabel: {
      [t.variable]: e != null ? e : r,
      [n.variable]: "calc(".concat(e != null ? e : r, " / 2.5)")
    }
  });
}
const S = {
  "2xs": a("4"),
  xs: a("6"),
  sm: a("8"),
  md: a("12"),
  lg: a("16"),
  xl: a("24"),
  "2xl": a("32"),
  full: a("100%")
}, B = h({
  baseStyle: C,
  sizes: S,
  defaultProps: {
    size: "md"
  }
});
export {
  B as avatarTheme
};
